// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__YQs-4","alertIcon":"ConfirmModal_alertIcon__3Zto0"};